export default __webpack_public_path__ + "static/media/regalxReal04_downloadMT4.e9f4b680.png";